import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M88.5 14a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M77.379 2.541a1.5 1.5 0 0 1 0 2.122l-9.994 9.994a1.5 1.5 0 1 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M65.263 2.541a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.5 1.5 0 1 1-2.122 2.122l-9.994-9.994a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path fill="#D8FFFF" d="M55.5 105a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M17.129 75.104a1.5 1.5 0 0 1 1.5 1.5v14.133a1.5 1.5 0 0 1-3 0V76.604a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M8.563 83.67a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H10.063a1.5 1.5 0 0 1-1.5-1.5M34.067 96.63a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M58 93c19.33 0 35-15.67 35-35S77.33 23 58 23 23 38.67 23 58s15.67 35 35 35"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M54.036 42.642A2.25 2.25 0 0 1 55.61 42h2.761a2.25 2.25 0 0 1 2.25 2.25v25.915a2.25 2.25 0 0 1-4.5 0V46.899l-6.297 6.166a2.25 2.25 0 0 1-3.148-3.216z"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M48.396 70.165a2.25 2.25 0 0 1 2.25-2.25h13.379a2.25 2.25 0 0 1 0 4.5H50.646a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#D8FFFF"
      d="M88.315 55.16c9.049 0 16.384-7.335 16.384-16.384s-7.335-16.384-16.384-16.384-16.384 7.336-16.384 16.384S79.266 55.16 88.315 55.16"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M96.028 31.84a2.25 2.25 0 0 1 .545 3.135L89.4 45.168a2.25 2.25 0 0 1-3.209.49l-5.663-4.342a2.25 2.25 0 0 1 2.738-3.57l3.803 2.915 5.824-8.276a2.25 2.25 0 0 1 3.135-.545"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconAllinOneBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconAllinOneBrand);
export default Memo;
